import React from "react";
import "@mui/icons-material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";

const SearchText = ({
  handleDeleteRecent,
  handleSearchSubmit,
  searchBoxRef,
  recentSearches,
  setSearchQuery,
  searchQuery,
}) => {
  return (
    <div
      ref={searchBoxRef}
      className="absolute top-20 left-[63%] transform -translate-x-1/2 bg-white shadow-lg rounded-2xl p-4 w-80 z-50"
    >
      {/* Search input and recent searches inside */}
      <form onSubmit={handleSearchSubmit}>
        <div className="flex items-center bg-gray-100 rounded-full px-4 py-2">
          <SearchIcon className="text-gray-500 mr-2" />
          <input
            type="text"
            placeholder="Search products..."
            className="bg-transparent flex-1 outline-none  text-black"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
      </form>
      {recentSearches.length > 0 && (
        <div className="mt-4 space-y-2 max-h-48 overflow-y-auto">
          {recentSearches.map((item, index) => (
            <div
              key={index}
              className="flex items-center justify-between bg-gray-50 px-4 py-2 rounded-lg hover:bg-gray-100"
            >
              <span className=" text-gray-700 truncate">{item}</span>
              <CloseIcon
                className="text-gray-400 cursor-pointer"
                fontSize="small"
                onClick={() => handleDeleteRecent(index)}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SearchText;
